(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7415],{

/***/ 27415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ components_CollectDataDetails_CollectDataDetails; }
});

// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../libs/matcha/components/FeatureBox/index.ts
var FeatureBox = __webpack_require__(33514);
// EXTERNAL MODULE: ../../libs/matcha/components/ColumnTrack/index.ts + 2 modules
var ColumnTrack = __webpack_require__(85735);
// EXTERNAL MODULE: ../../libs/matcha/components/Icons/Brandbook.ts + 93 modules
var Brandbook = __webpack_require__(52065);
// EXTERNAL MODULE: ../../libs/matcha/components/IconWrapper/index.ts + 2 modules
var IconWrapper = __webpack_require__(79600);
// EXTERNAL MODULE: ../../libs/matcha/recipes/CopyText/index.ts + 2 modules
var CopyText = __webpack_require__(94136);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Section/index.ts + 2 modules
var Section = __webpack_require__(88392);
// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var Image = __webpack_require__(4203);
// EXTERNAL MODULE: ./src/views/Engineering/components/CollectDataDetails/assets/CollectDataDetails@2x.png
var CollectDataDetails_2x = __webpack_require__(95188);
var CollectDataDetails_2x_default = /*#__PURE__*/__webpack_require__.n(CollectDataDetails_2x);
// EXTERNAL MODULE: ./src/views/Engineering/components/CollectDataDetails/assets/CollectDataDetails.webp
var CollectDataDetails = __webpack_require__(21137);
var CollectDataDetails_default = /*#__PURE__*/__webpack_require__.n(CollectDataDetails);
// EXTERNAL MODULE: ./src/views/Engineering/components/CollectDataDetails/assets/CollectDataDetails@2x.webp
var assets_CollectDataDetails_2x = __webpack_require__(80971);
var assets_CollectDataDetails_2x_default = /*#__PURE__*/__webpack_require__.n(assets_CollectDataDetails_2x);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ./src/views/Engineering/components/CollectDataDetails/CollectDataDetailsImage.tsx







var CollectDataDetailsImage = function CollectDataDetailsImage() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
    children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
      type: "image/webp",
      srcSet: "".concat((CollectDataDetails_default()), ", ").concat((assets_CollectDataDetails_2x_default()), " 2x")
    }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* default */.Z, {
      width: "640",
      height: "550",
      src: (CollectDataDetails_2x_default()),
      alt: "Collect Data Details",
      loading: "lazy"
    })]
  });
};

/* harmony default export */ var CollectDataDetails_CollectDataDetailsImage = (CollectDataDetailsImage);
;// CONCATENATED MODULE: ./src/views/Engineering/components/CollectDataDetails/CollectDataDetails.tsx


function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }










var copy = {
  heading: "Data collection from anywhere",
  description: "Collect user events from any platform with our simple analytics API."
};
var features = [{
  heading: "Pull data from any platform",
  description: "Send us data from any part of your product: mobile, web, or server. We have performant, open-source libraries for every platform.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* DataCollectIcon */.BL, {})
}, {
  heading: "Enterprise-grade scale",
  description: "25,000+ companies collect over 1 trillion events every month on our APIs.",
  icon: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Brandbook/* DataScaleIcon */.g_, {})
}];

var CollectDataDetails_CollectDataDetails = function CollectDataDetails() {
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Wrapper, {
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* default */.ZP, {
      variant: "2Col",
      copyVariant: "narrow",
      children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Section/* Copy */.CK, {
        children: [(0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CopyText/* default */.ZP, {
          children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ResponsiveHeading, {
            tag: "h2",
            variant: "h2",
            children: copy.heading
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Description */.dk, {
            children: copy.description
          }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CopyText/* Link */.rU, {
            href: "https://segment.com/docs/connections/spec/track/",
            children: "Explore Tracking API"
          })]
        }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrackWrapper, {
          children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ColumnTrack/* default */.Z, {
            gap: "small",
            children: features.map(function (feature) {
              return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* default */.ZP, {
                alignment: "left",
                headerPosition: "left",
                children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Header */.h4, {
                  children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrapper/* default */.Z, {
                    elevation: 1,
                    variant: "circle",
                    children: feature.icon
                  })
                }), (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(FeatureBox/* Body */.uT, {
                  children: [(0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Title */.Dx, {
                    children: feature.heading
                  }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FeatureBox/* Text */.xv, {
                    children: feature.description
                  })]
                })]
              }, feature.heading);
            })
          })
        })]
      }), (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section/* Contents */.AU, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollectDataDetails_CollectDataDetailsImage, {})
      })]
    })
  });
};

var Wrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("section",  true ? {
  target: "e1l752os2"
} : 0)( true ? {
  name: "vetbs0",
  styles: "display:grid"
} : 0);

var ColumnTrackWrapper = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1l752os1"
} : 0)( true ? {
  name: "1lw3ul3",
  styles: "margin-top:40px"
} : 0);

var ResponsiveHeading = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(CopyText/* Heading */.X6,  true ? {
  target: "e1l752os0"
} : 0)(function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("lg");
}, "{max-width:340px;}" + ( true ? "" : 0));

/* harmony default export */ var components_CollectDataDetails_CollectDataDetails = (CollectDataDetails_CollectDataDetails);
;// CONCATENATED MODULE: ./src/views/Engineering/components/CollectDataDetails/index.ts


/***/ }),

/***/ 95188:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectDataDetails@2x-a344ff4002a24ede63d119921408ac04.png";

/***/ }),

/***/ 21137:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectDataDetails-e40e4467fb65fe5cf17b3e5e45f40f48.webp";

/***/ }),

/***/ 80971:
/***/ (function(module) {

module.exports = "/_next/static/images/CollectDataDetails@2x-df9e05a47614e8af85376bfb0d9ea394.webp";

/***/ })

}]);